import type { CallbackInterface } from 'recoil'

import { logAppError } from 'Helpers/logger'

import { fetchRecipientsEngagement } from 'Pages/RecipientsList/recoil/services/engagement'
import { recipientsEngagementState } from 'Pages/RecipientsList/recoil/state/engagemet'
import { resultsState } from 'Pages/RecipientsList/recoil/state/results'

export const fetchRecipientsEngagementCallback =
  ({ snapshot, set }: CallbackInterface) =>
  async () => {
    const items = await snapshot.getPromise(resultsState)

    set(recipientsEngagementState, {
      status: 'loading',
      items: [],
    })

    try {
      const results = await fetchRecipientsEngagement(items)

      set(recipientsEngagementState, {
        status: 'ready',
        items: results,
      })
    } catch (error) {
      logAppError({
        Component: 'RecipientsList',
        Method: 'fetchRecipientsEngagementCallback',
        appError: error,
      })

      set(recipientsEngagementState, {
        status: 'error',
        items: [],
      })
    }
  }
